/** @jsxImportSource @emotion/react */
import React from 'react'
import {CardCategoryForm, CardCategoryPreview} from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/CardCategoryContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageCardCategory } = breadcrumbItems

const CreateCardCategory: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageCardCategory]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <CardCategoryForm />
        </div>
        <div css={styles.right}>
          <CardCategoryPreview />
        </div>
      </div>
    </Provider>
  )
}

export default CreateCardCategory
